 <div class="scenario-chart">
    <div class="scenario-chart__header">
        <p>{{'Calculated Value of '+_autoMl.dependentVariable}}</p>
        <div class="scenario-chart__hicons">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="20" viewBox="0 0 50 20" fill="none">
                <path d="M16.2483 15.2113L15.3104 6.92004C14.929 3.5489 12.0502 1 8.62435 1C5.19814 1 2.31931 3.5489 1.93832 6.92004L1 15.2113H16.2483Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.51196 15.2109C5.57493 17.1251 6.94178 18.6556 8.62348 18.6556C10.3048 18.6556 11.6717 17.1251 11.7347 15.2109" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M39.8367 5.41211L39.8367 14.2401" stroke="black" stroke-width="1.5"/>
                <path d="M44.2493 9.82422L35.4213 9.82422" stroke="black" stroke-width="1.5"/>
                <path d="M31.009 4.963C31.009 2.7743 32.7833 1 34.972 1H44.702C46.8907 1 48.665 2.7743 48.665 4.963V14.693C48.665 16.8817 46.8907 18.656 44.702 18.656H34.972C32.7833 18.656 31.009 16.8817 31.009 14.693V4.963Z" stroke="black" stroke-width="1.5"/>
            </svg>
        </div>
    </div>

    <div class="scenario-chart__chartSection">
        <div class="scenario-chart__legends">
            <div *ngFor="let item of _autoMl.scenarioSetList" class="scenario-chart__label">{{item.name}}</div>
        </div>
        <div class="scenario-chart__chart">
           <div class="scenario-chart__bars-set" >
              <div *ngFor="let item of _autoMl.scenarioSetList;let i=index" class="scenario-chart__bar" [ngClass]="{'disabled-color': _autoMl.scenarioSetList.length-1 !==i}" [ngStyle]="{width: (item.prediction_score /_autoMl.scenarioMaxValue)*100 +'%'}">
                <div class="count">{{item.prediction_score|number:'1.1-2'}}</div>
              </div>
           </div>
        </div>
    </div>

    <div class="scenario-chart__bottom-legends">
        <p>0</p>
        <p>{{_autoMl.scenarioMaxValue/4 |number:'1.1-2'}}</p>
        <p>{{_autoMl.scenarioMaxValue/2 |number:'1.1-2'}}</p>
        <p>{{(_autoMl.scenarioMaxValue/4)*3 |number:'1.1-2'}}</p>
        <p>{{_autoMl.scenarioMaxValue |number:'1.1-2'}}</p>
    </div>


    <div class="scenario-chart__bottom-label">
        Calculated Value
    </div>
 </div>
